import _ from 'lodash';
import * as consts from '../constants';
import commonFunctions from '../commonFunctions';

class userApi {
    static loadAgents(token, searchModel) {
        return userApi.loadUsers(token, searchModel);
    }

    static loadAgentsByNetowrk(token, networkId) {
        return;
    }

    static loadUsers(token, searchModel) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/user/filtered';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento degli Operatori!');
                    }
                }
            };
            req.send(JSON.stringify(searchModel));
        });
    }

    static loadUsersByNetowrk(token, networkId, roleId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/user/byNetwork?';
            if (!_.isUndefined(networkId))
                url = url + '&networkId=' + networkId;

            if (!_.isUndefined(roleId))
                url = url + '&roleId=' + consts.AUTHENTICATION.USER_ROLE.NetworkAgent;
            else
                url = url + '&roleId=' + roleId;

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento degli Operatori!');
                    }
                }
            };
            req.send();
        });
    }

    static loadUser(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/user/get/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento della Garanzia!');
                    }
                }
            };
            req.send();
        });
    }

    static loadBasicUser(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/user/getBasicUser/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento della Garanzia!');
                    }
                }
            };
            req.send();
        });
    }

    static saveUser(token, user) {
        return new Promise((resolve, reject) => {
            let method = 'POST';
            if (user.id > -1)
                method = 'PUT';

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/user/save', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 409) {
                        reject(req.response);
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(user));
        });
    }

    static saveBasicUser(token, user) {
        return new Promise((resolve, reject) => {
            let method = 'POST';
            if (user.id > -1)
                method = 'PUT';

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/user/saveBasicUser', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 409) {
                        reject(req.response);
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(user));
        });
    }

    // *******************************************************************************************************************
    //                                                      Documents 
    // *******************************************************************************************************************
    static eliminaDocumento(token, documentId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/user/document/'+ documentId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static caricaDocumento(token, networkId, file) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', process.env.REACT_APP_BASE_URL + '/api/user/document/' + networkId, true);
            xhr.setRequestHeader('Content-Length', file.size);
            xhr.setRequestHeader('X-Token', token);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status >= 200 && xhr.status < 400) {
                        resolve(JSON.parse(xhr.response));
                    } else if (xhr.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (xhr.status === 401 || xhr.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server nel caricamento del Contratto!');
                    }
                }
            };
            var formData = new FormData();
            formData.append('configurationFile', file);
            xhr.send(formData);
        });
    }
}

export default userApi;
